import { default as React, useState, useEffect } from "react";
import { useLocation, useParams } from "react-router-dom";
import { get } from "aws-amplify/api";
import 'containers/common/Detail.css';
import 'containers/property/TextPreview.css';
import { Button, Card, Col, Row } from "react-bootstrap";
import { PacmanLoader } from 'react-spinners';
import "containers/common/List.css";
import "containers/common/Table.css";

function TextPreview({ isAuthenticated }) {

	const location = useLocation();
	const params = useParams();
	const [isLoading, setIsLoading] = useState(true);
	const [text, setText] = useState("");
	const property_id = params.propertyid;

	// --- Data Fetching and Update Functions ---
	useEffect(() => {
		if (!isAuthenticated) return;

		async function fetchTextData() {
			const queryFilter = {
				propertyid: params.propertyid,
				text: location.search.replace("?propertyid=", "")
			};
			try {
				console.log("Inside getText() ", queryFilter);

				const options = { queryParams: queryFilter };
				const { body } = await get({
					apiName: "colin",
					path: `/properties/${property_id}/text`,
					options,
				}).response;

				const localResults = await body.json();
				console.log("API response: ", localResults);

				setText(localResults);
				setIsLoading(false);
				document.title = property_id + " Text preview";
			} catch (error) {
				console.error(error);
				alert(error + ". Please refresh the page (F5) to try again.");
				setIsLoading(false);
			}
		}
		fetchTextData();
	}, [isAuthenticated, property_id, location.search, params.propertyid]);

	return (
		<div className="preview">
			{isLoading && (
				<div className="outer-div">
					<div className="sweet-loading inner-div">
						<PacmanLoader
							cssOverride={{ display: "block", margin: "0 auto" }}
							size={20}
							color={"#e03c31"}
							loading={isLoading}
						/>
					</div>
				</div>
			)}
			{text && isAuthenticated && !isLoading && (
				<Row>
					<Col>
						<div className="text">
							{text.length > 0 && (
								<div>
									<Button onClick={() => window.print()}>Print</Button>

									<Card>
										<Card.Body>
											<Row>
												<Col>
													<div className="BuildingText">
														<h5>Building Text</h5>
														{text[0].building_text}
													</div>
												</Col>
											</Row>
										</Card.Body>
									</Card>
									<Card>
										<Card.Body>
											<Row>
												<Col>
													<div className="ProposalText">
														<h5>Proposal Text</h5>
														{text[0].development_proposal_text}
													</div>
												</Col>
											</Row>
										</Card.Body>
									</Card>
									<Card>
										<Card.Body>
											<Row>
												<Col>
													<div className="OccupantText">
														<h5>Occupant Text</h5>
														{text[0].occupant_text}
													</div>
												</Col>
											</Row>
										</Card.Body>
									</Card>
									<Card>
										<Card.Body>
											<Row>
												<Col>
													<div className="OwnerText">
														<h5>Owner Text</h5>
														{text[0].owner_text}
													</div>
												</Col>
											</Row>
										</Card.Body>
									</Card>
									<Card>
										<Card.Body>
											<Row>
												<Col>
													<div className="FullPreviewText">
														<h5>Cityscope Text</h5>
														<div className="content" dangerouslySetInnerHTML={{ __html: text[0].full_preview_text }}></div>
													</div>
												</Col>
											</Row>
										</Card.Body>
									</Card>
								</div>
							)}
						</div>
					</Col>
				</Row>
			)}
		</div>
	);
}

export default TextPreview;